import type { UserRepository } from '../repository/UserRepository';
import type { UserProfile } from '../entity/UserTypes';

export class GetUserDetailsUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(userId: string): Promise<UserProfile> {
    if (!userId?.trim()) {
      throw new Error('user_id is required');
    }
    return this.repository.getUserDetails(userId);
  }
}

